import React, { useState } from "react";

import config from "@app/config";
import { useMobile } from "@app/scripts/react-hooks/mobile";
import { Button } from "@app/scripts/react-general-components/Button";
import { Drawer } from "@app/scripts/react-general-components/Drawer";
import { LocalisationObject } from "@app/scripts/types";
import { AustraliaSvg } from "@app/scripts/react-geolocation/components/AustraliaSvg";

export type GeolocationDrawerProps = {
  storeConfig?: any;
  localisation: LocalisationObject;
};

export const GeolocationDrawer: React.FC<GeolocationDrawerProps> = (props) => {
  const { storeConfig, localisation } = props;
  const isMobile = useMobile();

  const isKids = storeConfig?.shopify_domain === "industrie-kids";
  const isNorthAmerica = storeConfig.region === "US";
  const northAmerica = ['United States', 'Canada', 'Mexico'];
  const unitedKingdom = 'United Kingdom'
  const newZealand = 'New Zealand'
  // Europe doesn't utilise a variable, it goes based on if the country utilises the currency "EUR" due to there being a large amount of European countries

  const button = () => (
    < div className="localization-form__selected" >
      {isNorthAmerica && northAmerica.includes(localisation?.country) || isKids && northAmerica.includes(localisation?.country) ? localisation.country : unitedKingdom === localisation?.country ? "United Kingdom" : newZealand === localisation?.country ? "New Zealand" : localisation?.currency_code === "EUR" ? "Europe" : !isNorthAmerica ? "Australia" : "United States"} / {" "}
      {isNorthAmerica && northAmerica.includes(localisation?.country) || isKids && northAmerica.includes(localisation?.country) || unitedKingdom === localisation?.country || localisation?.currency_code === "EUR" || newZealand === localisation?.country ? localisation.currency_symbol + localisation.currency_code : !isNorthAmerica ? "$AUD" : "$USD"}

      {
        (
          isNorthAmerica && northAmerica.includes(localisation?.country) || isKids && northAmerica.includes(localisation?.country) ? (
            <ui-icon name={localisation?.country === "United States" ? "icon-america" : `icon-${localisation?.country?.toLowerCase()}`}></ui-icon>
          ) : unitedKingdom === localisation?.country ? (
            <ui-icon name="icon-uk"></ui-icon>
          ) : localisation?.currency_code === "EUR" ? (
            <ui-icon name="icon-eu"></ui-icon>
          ) : newZealand === localisation?.country ? (
            <ui-icon name="icon-nz"></ui-icon>
          ) : !isNorthAmerica ? (
            <AustraliaSvg width={16} height={16} />
          ) : (
            <ui-icon name="icon-america"></ui-icon>
          )
        )
      }
    </div >
  );

  return (
    <Drawer
      customButton={button}
      opensFrom={isMobile ? "bottom" : "right"}
      heading="Confirm Your Location"
      drawerClassName="geolocation__drawer"
    >
      <DrawerContent {...props} />
    </Drawer>
  );
};

const DrawerContent = ({ storeConfig, toggleOpen }) => {
  const [selected, setSelected] = useState<string>(storeConfig.region);

  const countryMatchesSelected = storeConfig.region === selected;

  const btnText = countryMatchesSelected
    ? "Continue Shopping"
    : `Shop the ${selected === "US" ? "North American" : "Australian"} site`;

  const onClick = () => {
    const link = config.stores[selected === "US" ? "industrie-australia" : "industrie-clothing"].url;
    countryMatchesSelected ? toggleOpen?.() : (window.location.href = link);
  };

  return (
    <div className="geolocation__drawer-inner page-width text-brand-dark-grey">
      <div className="geolocation__drawer-buttons">
        <button
          onClick={() => setSelected("AU")}
          className="text-lg bold geolocation__drawer-bigbtn"
          style={{ borderColor: selected !== "US" ? "black" : undefined }}
        >
          <ui-icon name="icon-globe"></ui-icon>
          Australia & Rest Of World
        </button>
        <button
          onClick={() => setSelected("US")}
          className="text-lg bold geolocation__drawer-bigbtn"
          style={{ borderColor: selected === "US" ? "black" : undefined }}
        >
          <div className="geolocation__popup-flags">
            <ui-icon name="icon-america"></ui-icon>
            <ui-icon name="icon-canada"></ui-icon>
            <ui-icon name="icon-mexico"></ui-icon>
          </div>
          North America
        </button>
      </div>
      <Button onClick={onClick} label={btnText} variant="secondary" className="fullwidth" />
    </div>
  );
};
